import { env } from '@shared/config/env';

export const APP_NAME = env.appName;

export const QUERY_KEYS = {
  currentUser: ['auth', 'me'] as const,
  twoFactorStatus: ['auth', 'two-factor'] as const,
  sessions: ['auth', 'sessions'] as const,
  settings: ['settings'] as const,
  themes: ['themes'] as const,
  notifications: ['notifications'] as const,
  roles: ['roles'] as const,
  workspaces: ['workspaces'] as const,
  workspace: (id: string) => ['workspaces', id] as const,
  workspaceMembers: (id: string) => ['workspaces', id, 'members'] as const,
  workspaceInvitations: (id: string) => ['workspaces', id, 'invitations'] as const,
  invitation: (token: string) => ['invitations', token] as const,

  collections: (workspaceId: string) => ['workspaces', workspaceId, 'collections'] as const,
  collection: (id: string) => ['collections', id] as const,
  collectionVariables: (id: string) => ['collections', id, 'variables'] as const,

  folders: (collectionId: string, parentId?: string | null) =>
    ['collections', collectionId, 'folders', parentId ?? null] as const,
  folder: (id: string) => ['folders', id] as const,

  apiRequests: (collectionId: string, folderId?: string | null) =>
    ['collections', collectionId, 'requests', folderId ?? null] as const,
  apiRequest: (id: string) => ['requests', id] as const,

  environments: (workspaceId: string) => ['workspaces', workspaceId, 'environments'] as const,
  environment: (id: string) => ['environments', id] as const,

  globalVariables: (workspaceId: string) => ['workspaces', workspaceId, 'globals'] as const,

  variableHygiene: (workspaceId: string) =>
    ['workspaces', workspaceId, 'variable-hygiene'] as const,

  history: (workspaceId: string, params?: unknown) =>
    ['workspaces', workspaceId, 'history', params ?? {}] as const,
  historyEntry: (id: string) => ['history', id] as const,

  cookies: (workspaceId: string) => ['workspaces', workspaceId, 'cookies'] as const,

  search: (workspaceId: string, query: string) =>
    ['workspaces', workspaceId, 'search', query] as const,

  mockServers: (workspaceId: string) => ['workspaces', workspaceId, 'mock-servers'] as const,

  activityLogs: (workspaceId: string, params?: unknown) =>
    ['workspaces', workspaceId, 'activity-logs', params ?? {}] as const,

  requestExamples: (requestId: string) => ['requests', requestId, 'examples'] as const,
};

export const STORAGE_KEYS = {
  themePreference: 'eze:theme',
  workbenchTabs: 'eze:workbench-tabs',
  apiTesterRequestPanelSize: 'api-tester-request-panel-size',
  apiTesterResponseHidden: 'api-tester-response-hidden',
  apiSidebarWidth: 'api-sidebar-width',
  apiConsoleHeight: 'api-console-height',
};
